"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegalAcceptanceItemDtoKindEnum = void 0;
exports.instanceOfLegalAcceptanceItemDto = instanceOfLegalAcceptanceItemDto;
exports.LegalAcceptanceItemDtoFromJSON = LegalAcceptanceItemDtoFromJSON;
exports.LegalAcceptanceItemDtoFromJSONTyped = LegalAcceptanceItemDtoFromJSONTyped;
exports.LegalAcceptanceItemDtoToJSON = LegalAcceptanceItemDtoToJSON;
exports.LegalAcceptanceItemDtoToJSONTyped = LegalAcceptanceItemDtoToJSONTyped;
/**
 * @export
 */
exports.LegalAcceptanceItemDtoKindEnum = {
    Terms: 'terms',
    Privacy: 'privacy'
};
/**
 * Check if a given object implements the LegalAcceptanceItemDto interface.
 */
function instanceOfLegalAcceptanceItemDto(value) {
    if (!('kind' in value) || value['kind'] === undefined)
        return false;
    return true;
}
function LegalAcceptanceItemDtoFromJSON(json) {
    return LegalAcceptanceItemDtoFromJSONTyped(json, false);
}
function LegalAcceptanceItemDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'kind': json['kind'],
        'version': json['version'] == null ? undefined : json['version'],
    };
}
function LegalAcceptanceItemDtoToJSON(json) {
    return LegalAcceptanceItemDtoToJSONTyped(json, false);
}
function LegalAcceptanceItemDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'kind': value['kind'],
        'version': value['version'],
    };
}
